/**
 * Log in or create an account - one way for the login page and the sign-in pop-up (Stage 8, 2026-10-23), so the two
 * can never check or word things differently. Returns { error } with words a person can act on, or { ok: true }.
 *
 * "Signed in here before" (hasAccountHere) is remembered per device: the pop-up opens on Log in for a phone someone has
 * signed in on, on Create account for one nobody has (Sam: assume a new person when we can).
 */
import { supabase } from '../../supabaseClient';
import { clearPasswordRecoveryActive } from '../../utils/authRecovery';
import {
  friendlyAuthError,
  isPasswordAcceptable,
  isValidEmail,
  normalizeEmail,
} from '../authValidation';

const HAS_ACCOUNT_KEY = 'prii.hasAccountHere';
export function hasAccountHere() {
  try {
    return window.localStorage.getItem(HAS_ACCOUNT_KEY) === '1';
  } catch {
    return false;
  }
}
export function markHasAccountHere() {
  try {
    window.localStorage.setItem(HAS_ACCOUNT_KEY, '1');
  } catch {
    /* private mode */
  }
}

export async function submitAuth({ isSignUp, email, password, name = '' }) {
  const cleanEmail = normalizeEmail(email);
  const displayName = name.trim();
  const problem =
    (isSignUp && !displayName && 'Enter a display name.') ||
    (!cleanEmail && 'Enter your email address.') ||
    (!isValidEmail(cleanEmail) && 'Enter a full email, like name@example.com.') ||
    (!password && 'Enter your password.') ||
    (isSignUp &&
      !isPasswordAcceptable(password) &&
      'Your password needs everything on the list.') ||
    null;
  if (problem) return { error: problem, field: true };
  try {
    const { error } = isSignUp
      ? await supabase.auth.signUp({
          email: cleanEmail,
          password,
          options: { data: { display_name: displayName } },
        })
      : await supabase.auth.signInWithPassword({ email: cleanEmail, password });
    if (error) throw error;
    clearPasswordRecoveryActive();
    markHasAccountHere();
    return { ok: true };
  } catch (error) {
    return { error: friendlyAuthError(error) };
  }
}
